export const homeEnTranslation = {
  home: {
    welcomeText: "Welcome,",
    missingPaymentMethodsMessage: {
      heading: "Add a payment method",
      content:
        "We need a payment method on file to process your rent. You can add a card or link your bank.",
      paymentScreenContent:
        "We need a payment method on file to process your rent. You can add a card or link your bank. You also can configure the AutoPay option, once you add your default payment method.",
    },
    isNotAcceptPaymentStatus: {
      heading: "Unable to process the payment",
      content:
        "At this moment, we are unable to accept online payments for your balance. Your account is only able to receive payment in full via certified funds. Please contact the property team if you have any questions.",
    },
    renewalBanner: {
      title: "It's time to renew your lease!",
      link: "Click here",
      reviewOffer: "Please review your offer now.",
    },
    rebind: {
      title: "Switch lease",
      titleConnect: "Connect a lease",
      intro:
        "Your account shows one lease at a time. Switch to another lease under your name when you need to pay or view it. You can switch back. Payment methods stay on the lease where you saved them.",
      introConnect:
        "This login is not on a lease yet. Connect it to a lease under your name to pay or view that account.",
      connectedNow: "You're on",
      youAreOn: "You are on",
      unitStatus: "Unit {{unit}} · {{status}}",
      none: "You don't have another lease under your name.",
      noneConnect: "No lease under your name is available to connect yet.",
      switchTo: "Switch to this lease",
      connectTo: "Connect to this lease",
      switch: "Switch",
      connect: "Connect",
      cancel: "Cancel",
      homeOffer: "Connect to {{target}}",
      noLeaseTitle: "Connect this login to a lease",
      noLeaseSingle:
        "This login is not on a lease yet. Connect it to {{place}} to pay and view that account.",
      noLeaseChoose:
        "This login is not on a lease yet. Choose the lease you need to pay or view.",
      chooseLease: "Choose a lease",
      confirmSwitch:
        "Switch from {{from}} ({{fromStatus}}) to {{to}} ({{toStatus}})? You can switch back. Payment methods stay on the lease where you saved them.",
      confirmConnect:
        "Connect your account to {{to}} ({{toStatus}})? You can switch later. Payment methods stay on the lease where you saved them.",
      error: "That lease could not be switched. Try again.",
      loadError: "Leases could not be loaded. Try again.",
    },
    noLeaseMessage: {
      title: "No Active Lease",
      description:
        "You currently don't have an active or upcoming lease with us. Please ",
      contactLink: "reach out to us",
      descriptionEnd: " if you believe this is an error.",
      viewApplications:
        "If you have applied with us, please view your applications ",
      here: "here",
    },
    moveInConditionBanner: {
      title: "Complete your move-in condition form",
      content:
        "Report any defects, damage, safety issues, or pest concerns by {{dueDate}}.",
      button: "Start form",
    },
    pendingApplications: {
      title: "Your applications",
      subtitle: "These applications still need your attention.",
      unit: "Unit",
      moveInDate: "Move-in date",
      propertyFallback: "Property",
      statusIncomeNeeded: "Income needed",
    },
    welcomMessageModal: {
      content: "Thanks for signing up on TenantPort. You now have access to:",
      block1: {
        heading: "Hassle-Free Payments",
        content: `No more checks, no more stamps. Pay your rent at your convenience from anywhere and at any time. Or leave it on AutoPay so you don't miss a payment.`,
      },
      block2: {
        heading: "Quick Maintenance Requests",
        content: `Encounter an issue? Submit a maintenance request with just a few taps with a photo, and our team will be on it in no time.`,
      },
      block3: {
        heading: "Rent Reporting",
        content: `Boost your credit score by simply paying your rent. With our new app, your on-time payments can now reflect positively on your credit report.`,
      },
    },
  },
};
